import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-piechart',
  templateUrl: './piechart.component.html',
  styleUrls: ['./piechart.component.scss']
})
export class PiechartComponent implements OnInit {

  public pieChartLabels: string[] = ['Paid Amount', 'Pending Amount'];
  @Input() public pieChartData: number[] = [];
  public pieChartType = 'pie';
  public colors: any[] = [{ backgroundColor: ['#5BC35C', '#D96973'] }];

  ngOnInit() {

  }
  // events
  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }

}
